import React from 'react';

const SvgDownCarrot = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M12 15.6L5.765 9.3h12.47L12 15.6z" />
  </svg>
);

export default SvgDownCarrot;
